module.exports = {
    name: "default",
    default: {
        variableLess: "../src/assets/styles/theme/default.less"
    },
    custom: {
        variableLess: "../src/assets/styles/theme/custom.less"
    },
    cscecGrey: {
        variableLess: "../src/assets/styles/theme/cscecGrey.less"
    }
};



//////////////////
// WEBPACK FOOTER
// ./config/system.js
// module id = mvz5
// module chunks = 38